import React from 'react';
import { Accordion, Icon, Table } from 'semantic-ui-react';
import { AccessLogsByCredentials } from '../AccessLogsByCredentials';
import styles from '../styles.module.scss';

export const AccessLogTableRow = ({ row, index, activeIndex, onTitleClick }) => {
  const isExpanded = activeIndex === index;

  return (
    <>
      <Table.Row
        onClick={() => onTitleClick(index)}
        style={{ cursor: 'pointer' }}
        active={isExpanded}
      >
        <Table.Cell>{row.category || '-'}</Table.Cell>
        <Table.Cell>{row.time || '-'}</Table.Cell>
        <Table.Cell>{row.user || '-'}</Table.Cell>
        <Table.Cell>{row.company || '-'}</Table.Cell>
        <Table.Cell>{row.zone || '-'}</Table.Cell>
        <Table.Cell>{row.deviceName || '-'}</Table.Cell>
        <Table.Cell>{row.credentials.image || '-'}</Table.Cell>
        <Table.Cell>
          <div className={styles.expandedAccessLogCell}>
            <span>{row.detail || '-'}</span>
            <Icon name={isExpanded ? 'chevron up' : 'chevron down'} />
          </div>
        </Table.Cell>
      </Table.Row>
      {isExpanded && (
      <Table.Row>
        <Table.Cell colSpan={8}>
          <Accordion active={isExpanded}>
            <Accordion.Content active={isExpanded}>
              <AccessLogsByCredentials row={row} />
            </Accordion.Content>
          </Accordion>
        </Table.Cell>
      </Table.Row>
      )}
    </>
  );
};
